import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #ececec;   
`;
export const Content = styled.div`
    flex: 4;
    display:flex;
    flex-direction: column;
    
    padding: 5px 5px;
    color: black;
    text-decoration:none;

    :hover{
        background-color: #ececec;
        cursor:pointer;
    }
`

export const RightControl = styled.div`
    flex: 1;
    max-width: 100px;
    display: flex;
    flex-direction: column;
    padding: 0 5px;
`


export const Button = styled.button`
    padding: 3px 5px;
    font-size: 0.9rem;
    outline: none;
    border:1px solid transparent;
    border-color: var(--morienGreen);
    border-radius: 3px;
    background-color: var(--morienGreen);
    color: white;
    cursor: pointer;
    :active{
        background-color: #32cd32;            
    }
`